export function RecurringBuyDetailsSkeleton() {
  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex flex-row w-full flex-1">
        <div className="h-10 flex-grow rounded-t-2xl skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="h-10 flex-grow skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="h-10 flex-grow skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="h-10 flex-grow rounded-b-2xl skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="h-10 flex-grow rounded-t-2xl skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="h-10 flex-grow skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="h-10 flex-grow skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="h-10 flex-grow rounded-b-2xl skeleton" />
      </div>
    </div>
  );
}
